import React from "react";

type BuildingIconProps = React.SVGProps<SVGSVGElement> & { color?: string };

export const BuildingIcon = ({ width = 24, height = 24, color = "#79808A", ...props }: BuildingIconProps) => (
  <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    {/* Three isometric boxes: 1 on top, 2 on bottom */}
    <path
      d="M12 2 L17 5 L17 10 L12 13 L7 10 L7 5 Z M7 5 L12 8 L17 5 M12 8 L12 13 M2 13 L7 10 L12 13 L12 18 L7 21 L2 18 Z M2 13 L7 16 L12 13 M7 16 L7 21 M12 13 L17 10 L22 13 L22 18 L17 21 L12 18 Z M12 13 L17 16 L22 13 M17 16 L17 21"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default BuildingIcon;
